import { render } from "./InputCredentials.vue?vue&type=template&id=bb604ade&scoped=true"
import script from "./InputCredentials.vue?vue&type=script&lang=js"
export * from "./InputCredentials.vue?vue&type=script&lang=js"

import "./InputCredentials.vue?vue&type=style&index=0&id=bb604ade&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb604ade"]])

export default __exports__